module.exports = __webpack_public_path__ + "img/close_icon.e9bfff56.png";